var App = App || {};

App.Accessibility = (function ($) {
    "use strict";

    function init() {
        $("#SkipToOnlineBanking").on("click", function () {
            $(".header-login .login-form-fields .userid").focus();
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Accessibility.init();
});